import { IApplicationState } from '../../types/redux';
import { getUser } from '../user';

export function selectBrokerConsultantBannerAvailable(state: IApplicationState) {
  const user = getUser(state);
  const isAgent = user.isAuthenticated && user.isAgent;

  return state.config.isBrokerConsultantBannerEnabled && !isAgent;
}
